import React from 'react'

import classNames from 'classnames'

import { Button, ButtonProps } from 'ui/components/Button'

import { useFileUploadTriggerState } from './hooks/useFileUploadTriggerState'

import { FileUploadTriggerStyle } from './FileUpload.css'

type FileUploadTriggerProps = ButtonProps

export const FileUploadTrigger: React.FC<FileUploadTriggerProps> = ({
    className,
    onClick: onClickProp,
    ...props
}) => {
    const { onClick, inputId, disabled } = useFileUploadTriggerState({ onClickProp })

    return (
        <Button
            variant="primary"
            size="m"
            className={classNames(FileUploadTriggerStyle, className)}
            onClick={onClick}
            aria-controls={inputId}
            {...props}
            disabled={disabled}
        >
            Select files
        </Button>
    )
}
